import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import Loader from 'components/Loader';
import { loginConfig } from 'auth0/login-config';
import { useNavigate, useParams } from 'react-router-dom';
import { AuthorizationParams } from '@auth0/auth0-spa-js/src/global';
import { LoginRouteParams } from 'app/App';

export const Login = () => {
	const { loginWithRedirect, isLoading, isAuthenticated } = useAuth0();
	const navigate = useNavigate();
	const { token, schoolId } = useParams() as LoginRouteParams;

	useEffect(() => {
		if (isLoading) return;

		// if already logged in, redirect home
		if (isAuthenticated) {
			navigate('/');
		} else {
			const extraAuthParams: AuthorizationParams = {
				token,
				schoolId,
			};
			loginWithRedirect(loginConfig('/', extraAuthParams));
		}
	}, [
		isAuthenticated,
		isLoading,
		loginWithRedirect,
		navigate,
		schoolId,
		token,
	]);

	return <Loader />;
};

// for React.lazy
export default Login;
